export const gradeText = {
  "01": "S",
  "02": "A",
  "03": "B",
  "04": "C",
  "05": "D",
  "06": "E"
};
export const getGradeLabel = (range) => {
  if (!range) return "";
  const [start, end] = range.split(",").map(num => num.padStart(2, "0"));
  return `${gradeText[start]} → ${gradeText[end]}`;
};

export const generateGradeRangeOptions = (numOfGrades) => {
  const maxGrade = 6;
  const options = [];

  for (let start = 1; start <= maxGrade - numOfGrades + 1; start++) {
    const end = start + parseInt(numOfGrades) - 1;
    const value = `${start},${end}`;
    const label = getGradeLabel(value);
    options.push({ value, label });
  }

  return options;
};

export const GRADE_CODES = ['S', 'A', 'B', 'C', 'D', 'E'];

export const getStickerId = (gradeIndex) => String(gradeIndex + 1).padStart(2, '0');